import { moment } from "../../../../../vendor";
import t from "../../../helpers/t";
import { Span } from "../styled_components/divs";
import { rbac } from "../index";
import React from "react";
import SwitchPaddle from "../../../components/switchpaddle";
import { dateFormat } from "../../../../utils/FormatHelper";
import { Biscuit } from "../../../../utils";

const ItemLoginWeb = (props) => {
  const {
    localVoucherLogin,
    voucherLoginPending,
    onChangeStatus,
    currentUrl,
    onRemoveVoucherLogin,
  } = props;
  let language = Biscuit.get("user.lang").replace("-", "_");
  return (
    <>
      <div
        className={
          "inb-c-item inb-c-item--resource row hide-for-small-only" +
          (localVoucherLogin.valid ? " not-marked" : " red-marked")
        }
        key={"web_div_row_" + localVoucherLogin.user_id + "_standard"}
      >
        <div
          className="large-3 medium-3 small-6 column inb-order-big padding-1"
          id="order-id"
          key={"web_div_voucher_id_" + localVoucherLogin.user_id}
        >
          <Span title={"ID"}>{localVoucherLogin.username}</Span>
        </div>
        <div
          className="large-3 medium-3 small-8 column inb-order-big"
          id="description-voucher"
          key={"div_voucher_description_" + localVoucherLogin.user_id}
        >
          <span
            title={moment(localVoucherLogin.validTo).format(dateFormat(language, true))}
            className="text-nowrap"
          >
            {moment(localVoucherLogin.validTo).format(dateFormat(language, true))}
          </span>
        </div>
        <div
          className="medium-2 small-7 column"
          id="inb-contingent"
          title={t("valid", null, "capital")}
          key={"div_voucher_login_valid_" + localVoucherLogin.user_id}
        >
          {voucherLoginPending === localVoucherLogin.user_id ? (
            <>
              <span>
                <img
                  alt="RollingLoader"
                  className="rollingLoader colorize-black"
                  src={"assets/img/rolling_loader.svg"}
                />{" "}
              </span>
            </>
          ) : (
            <SwitchPaddle
              name={localVoucherLogin.user_id}
              disabled={rbac.hasPermission("editVoucher") ? "" : "disabled"}
              value={localVoucherLogin.valid}
              onChange={onChangeStatus}
              label={""}
            />
          )}
        </div>

        <div
          className="medium-4 small-4 medium-offset-0 column item-button-group padding-05"
          key={"div_resource_edit_" + localVoucherLogin.user_id}
        >
          <div className="medium-12 small-3 medium-offset-0 column" id="group-icon-one">
            {rbac.hasPermission("editVoucher") && (
              <div
                className="button-container-vouchers left"
                key={"div_voucher_button_container_edit_" + localVoucherLogin.user_id}
              >
                <a
                  href={"/vouchers/" + localVoucherLogin.user_id + currentUrl.search}
                  title={t("edit")}
                  key={"a_voucher_edit_" + localVoucherLogin.user_id}
                  data-inb-action-link="edit"
                >
                  <button
                    type="button"
                    className="inb-round-btn hollow round float-left"
                    key={"a_button_voucher_edit_" + localVoucherLogin.user_id}
                  >
                    <div className="inb-fi-edit"> </div>
                  </button>
                </a>
              </div>
            )}
            {rbac.hasPermission("removeVoucher") && (
              <div
                className="button-container-vouchers"
                key={"div_voucher_button_container_delete_" + localVoucherLogin.user_id}
              >
                <a
                  href="#"
                  className="inb-reservation__pdf2"
                  title={t("delete")}
                  key={"a_voucher_delete_" + localVoucherLogin.user_id}
                  data-inb-action-link="delete"
                >
                  <button
                    type="button"
                    className="inb-round-btn hollow round float-left"
                    key={"a_button_voucher_delete_" + localVoucherLogin.user_id}
                    onClick={() => onRemoveVoucherLogin(localVoucherLogin)}
                  >
                    <div className="inb-fi-remove"> </div>
                  </button>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemLoginWeb;
